import Emerald1 from '../../../media/Residentials/Emerald Cove/Emerald Cove.webp'
import Emerald2 from '../../../media/Residentials/Emerald Cove/Emerald Cove.webp'


const Emeraldimages =[
Emerald1,Emerald2
]

export default Emeraldimages;